export enum InputMode {
  Text = "text",
  Url = "url",
  Files = "files"
}
